import * as React from "react";
import "./flaggedemail.scss";
import { OutlookEmailobj } from "../../Entity/OutlookEmailobj";
import { IContextualMenuItem } from "office-ui-fabric-react/lib/ContextualMenu";
/* import Moment from "react-moment"; */
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import MIPADatePicker from "../Common/datepicker";
import FlaggedEmailDetail from './FlagedEmailDetail';
import { DateHelper } from "../../Helpers/DateHelper";
export interface Props {
  flaggedemail?: OutlookEmailobj;
  UpdateMethod;
  Phrases;
  taskfromflagemail;
  usertimezone;
}

export interface ContextualMenuState {
  DetailCalloutVisible?: boolean;
}

export default class FlaggedEmailItem extends React.Component<
  Props,
  ContextualMenuState,
  IContextualMenuItem
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      DetailCalloutVisible: false
    };
  }
  public render() {
    let webpartbody =
      this.props.flaggedemail.col < 0
        ? ["webpartbody", "overdue"].join(" ")
        : "webpartbody";
    let rowcss = "ms-Grid-row miparow";
    var categorylist = this.props.flaggedemail.categories
      ? this.props.flaggedemail.categories.join(", ")
      : "";
    let start = this.props.flaggedemail.flag.startDateTime
      ? new Date(this.props.flaggedemail.flag.startDateTime.dateTime)
      : "";
    let duedate = this.props.flaggedemail.flag.dueDateTime
      ? new Date(this.props.flaggedemail.flag.dueDateTime.dateTime)
      : "";
    return (
      <div className="webpart">
        <div className="webpartTitle">
          <span
            className="ms-Icon ms-Icon--Flag"
            style={{ marginRight: "10px", float: "left", marginTop: "6px" }}
          />
          {this.props.Phrases.title}
          <a
            className="editlink"
            target="_blank"
            href={this.props.flaggedemail.webLink}
            title='Open the mail in your online web mail'
          >
            <i className="ms-Icon ms-Icon--ReopenPages" />
          </a>
        </div>
        <div className={webpartbody}>
          <div className="ms-Grid">
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <FlaggedEmailDetail email={this.props.flaggedemail}/>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <label className="label">
                  {this.props.Phrases.from} :{" "}
                </label>
                <span className="breakinfo">
                    {this.props.flaggedemail.sender.emailAddress.name} - 
                    {this.props.flaggedemail.sender.emailAddress.address}
                </span>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div className="bodycontainer breakinfo">
                    {this.props.flaggedemail.bodyPreview}
                </div>               
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <label className="label">
                  {this.props.Phrases.category} :{" "}
                </label>
                <span>{categorylist}</span>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <label className="label">
                  {this.props.Phrases.startdate} :{" "}
                </label>
                {DateHelper.GetDisplayDatestring(start,false)}
               {/*  <Moment format="DD MMM YY">
                  {start.toString()}
                </Moment> */}
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div
                  className="dateleft"
                  title={this.props.Phrases.setfollowupdate}
                >
                  <MIPADatePicker
                    datevalue={duedate}
                    ChangeDate={date => {
                      this.UpdateFlaggedEmail(
                        this.props.flaggedemail.id,
                        date,
                        "Duedate",
                        "DateTime",
                        this.props.flaggedemail.col
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <label className="label">
                  {this.props.Phrases.importance} :{" "}
                </label>
                <span>{this.props.flaggedemail.importance}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="webpartfooter">
          <Checkbox
            className="checkbox"
            label={this.props.Phrases.markcomplete}
            onChange={() => {
              this.UpdateFlaggedEmail(
                this.props.flaggedemail.id,
                null,
                "completed",
                "DateTime",
                this.props.flaggedemail.col
              );
            }}
          />
          <button 
            onClick={()=>{this.createPlanTaskFromFlagEmail(this.props.flaggedemail.id);}}
            className="ms-Button ms-Button--default viewswitchbtn plannertask"
          >
            <i className="ms-Icon ms-Icon--Add" />
          </button>
        </div>
      </div>
    );
  }
  public UpdateFlaggedEmail=(itemId, newValue, propName, type, col)=> {
    
    let task;
    if (propName == "completed") {
      task = {
        flag: {
            flagStatus: 'notFlagged'
        }
    };
    } else if (propName == "Duedate") {
      task = {
        flag: this.props.flaggedemail.flag
      };
      task.flag.dueDateTime.dateTime=newValue;
      //task.flag.dueDateTime.timeZone=Helper.getTimeZoneId();   
      task.flag.dueDateTime.timeZone=this.props.usertimezone; 
      if (task.flag.startDateTime == null) {
        task.flag.startDateTime = {
            dateTime: newValue,
            timeZone: task.flag.dueDateTime.timeZone
        };
    }
    }
    this.props.UpdateMethod(this.props.flaggedemail.id, task, this.props.flaggedemail.col);
  }
  private GetGraphCompatiblemailID=(mailID)=> {
    if (mailID) {
        var find = '/';
        var re = new RegExp(find, 'g');
        mailID = mailID.replace(re, '-');
        do {
            mailID = mailID.replace('+', '_');
        } while (mailID.indexOf('+') >= 0);
        return mailID;
    } else {
        return mailID;
    }
  }
  private createPlanTaskFromFlagEmail=(mailid)=>{
    mailid=this.GetGraphCompatiblemailID(mailid);
    this.props.taskfromflagemail(mailid);
  }
  /*public handleLogChange = (event): void => {
    this.setState({ Summary: event.target.value });
  };*/
}
